<template>
  <Dialog type="history" :show="$bus.history.show" :title="$bus.transify['T_KU_HIS']">
    <template v-slot:dialog-content>
      <div class="history">
        <ul class="history-list" ref="historylist">
          <template v-for="(history, index) in History" >
            <ItemLine class="history-list-item" :key="index" :time="formateTime(history.time)" :history="history"/>
          </template>
        </ul>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from '@/components/common/Dialog.vue'
import ItemLine from '@/components/history/item.vue'
import { getTime, compare } from '@/utils/assist'
export default {
  components: {
    Dialog,
    ItemLine
  },
  data () {
    return {
      activeIdx: 0
    }
  },
  watch:{
    '$bus.history.show':{
      handler(val){
        if(!val){
          this.$refs.historylist.scrollTop = 0
        }
      }
    }
  },
  computed: {
    History () {
      const initHistory = this.$bus.history.data
      const history = []
      for (let order of initHistory) {
        const comItems = [] // 商品
        if (order.items.length > 0) {
          for (let item of order.items) {
            comItems.push({
              id: item.reward_id, // 商品id
              name: item.item_name, // 商品
              nums: item.item_num, // 商品数
              thumb: item.item_img // 商品缩略图链接
            })
          }
        }
        history.push({
          time: order.updated_at,
          discount: order.discount,
          price: order.discount_price,
          type: order.type,
          comItems: comItems
        })
      }
      return history.sort(compare('time', 'des'))
    }
  },
  methods: {
    formateTime (time) {
      return getTime(time)
    }
  }
}
</script>

<style lang="scss" scoped>
.history {
  width: 100%;
  @include px2res(margin-top, 10);
  .history-list {
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    @include px2res(padding, 0, 10);
    @include px2res(height, 106 * 3);
    .history-list-item {
      border-bottom: 2px solid #232124;
    }
    .history-list-item:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/history/index.vue